<template>
	<div v-if="!isDoneImported" class="tw-flex tw-h-full tw-flex-col tw-justify-between">
		<AppForm @submit="submit">
			<div>
				<div>
					<div class="tw-mb-3 tw-text-[32px] tw-font-bold tw-text-gray-950">
						{{ $t('integrations.add-products') }}
					</div>
					<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
						{{ $t('integrations.add-product-manually-step') }}
					</div>
				</div>

				<div class="tw-mt-4">
					<AppFileUpload
						class="tw-max-w-[500px]"
						:label="$t('integrations.upload-products')"
						:placeholder="$t('integrations.click-to-upload-file')"
						v-model="file"
						:btnLabel="$t('integrations.upload')"
						acceptTypes=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
						:allowedExts="['xlsx', 'xls', 'csv']"
						:rules="['required']"
					>
					</AppFileUpload>

					<div @click="downloadTemplate()">
						<AppSpinner v-if="downloadTemplateLoading" size="17px" />
						<span v-else class="te-text-gray-600 tw-cursor-pointer tw-underline">{{
							$t('integrations.download-products-template')
						}}</span>
					</div>
				</div>

				<div class="tw-mt-7 tw-flex tw-gap-3">
					<AppButton
						:label="$t('integrations.skip-step')"
						size="xl"
						class="tw-rounded-full"
						type="button"
						@click="skipStep"
						:disabled="skipStepLoading"
						:loading="skipStepLoading"
						secondary
						variant="gray"
					/>

					<AppButton
						:label="$t('integrations.upload-products')"
						size="xl"
						class="tw-rounded-full"
						variant="brand"
						customClasses="tw-gap-3"
						endIcon="assets/v2/image/icons/upload-02.svg"
						:disabled="loading"
						:loading="loading"
					/>
				</div>
			</div>
		</AppForm>
	</div>

	<div v-else>
		<ProductsImported :file="file"/>
	</div>
</template>

<script setup>
import AppSpinner from '@/v2/components/spinner.vue';
import ProductsImported from './products-imported';

import { ref } from 'vue';
import { useLinkMarketplaceStore } from '@/v2/modules/integrations/stores/link-marketplace';
import { Marketplace } from '@/v2/modules/integrations/entities/marketplace';
import { Alert } from '@/v2/plugins/alert';
import { useI18n } from 'vue-i18n';
import ImportsEntity from '@/v2/modules/imports/entities/imports';
import { base64ToBlob, downloadBlob } from '@/v2/utils/file-upload';
import { useRouter } from 'vue-router';

const linkMarketplaceStore = useLinkMarketplaceStore();

const { t } = useI18n();
const needHelpUrl = 'https://www.linker.com.sa/help-center-articles-ar/how-to-upload-products-to-a-whatsapp-catalog';
const skipStepLoading = ref(false);
const loading = ref(false);
const downloadTemplateLoading = ref(false);
const file = ref('');
const router = useRouter();
const isDoneImported = ref(false);

const skipStep = async () => {
	skipStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
		router.push('/v2/integrations/marketplaces');
	} finally {
		skipStepLoading.value = false;
	}
};

const downloadTemplate = async () => {
	downloadTemplateLoading.value = true;
	try {
		const response = await ImportsEntity.downloadTemplate('import/products-template');
		const blob = base64ToBlob(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
		downloadBlob(blob, 'products-template');
	} catch (error) {
		Alert.error(error?.response?.data?.message);
	} finally {
		downloadTemplateLoading.value = false;
	}
};

const submit = async () => {
	loading.value = true;
	const values = {
		file: file.value,
	};

	try {
		// await ImportsEntity.importFiles('import/products', values);
        isDoneImported.value = true;
	} catch (error) {
		Alert.error(error?.response?.data?.message);
	} finally {
		loading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
